import { IAppState } from '../../../../../AppModulesWrapper';
import { ICompetitorService } from '../types';

export const selectCompetitors = (state: IAppState): ICompetitorService[] => {
  return state.servicePickerWidgetV2.promotion.competitors;
};
